export default __webpack_public_path__ + "static/media/palaute-darkgray.1eb2867b.svg";